export const MuiAccordionSummary = {
  MuiAccordionSummary: {
    styleOverrides: {
      root: {
        padding: 0,
      },
    },
  },
};
